import { z } from 'zod';
import { queryUserListQuerySchema } from '~/generated/basic/zod-schema';

export type UserStatus = 'ACTIVE' | 'DISABLED' | (string & {});

export const accountMaintenanceSearchSchema = queryUserListQuerySchema
  .omit({ page: true, size: true })
  .extend({
    userStatus: z.string().optional(),
    sortField: z
      .enum(['userName', 'userStatus', 'lastLoginDatetime'])
      .default('lastLoginDatetime'),
    sortDirection: z.enum(['ASC', 'DESC']).default('DESC'),
    userId: z.string().optional(),
  });

export type AccountMaintenanceSearchParams = Omit<
  z.infer<typeof accountMaintenanceSearchSchema>,
  'userStatus'
> & {
  userStatus?: UserStatus;
};

export type SortField = AccountMaintenanceSearchParams['sortField'];
export type SortDirection = AccountMaintenanceSearchParams['sortDirection'];
